import IconTrackSvg from '@assets/images/svg/Icon-track.svg';
import React from 'react';
import { View } from 'react-native';

export interface IconTrackIconProps {
    size?: number;
    color?: string;
}

export function IconTrackIcon({ size = 25, color = '#4D4D4D' }: IconTrackIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <IconTrackSvg width={size} height={size} color={color} />
        </View>
    );
}

export default IconTrackIcon;
